<template>
	<div ref="essay" class="essay">
		<canvas :id="page.id"></canvas>
	</div>
</template>

<script>
import _ from "lodash";
import Utils from "@/services/Utils";
import $ from "jquery";
import store from "@/services/Store";
import Annotation from "@/components/viewer/Annotation";

export default {
	name: "PDFMedia",
	props: ["page", "chan"],
	components: { Annotation },
	data() {
		return {
			events: [],
			sizes: [0.5, 0.65, 0.8, 1, 1.2, 1.5, 1.8, 2],
			rotate: 0,
			angleEnabled: false,
			angleState: {},
			highlightEnabled: false
		};
	},

	created() {
		console.log(this.page);
		//Zoom
		var zoom = () => {
			this.drawPDF();
		};
		this.events.push({ key: "zoom-in", val: zoom });
		this.events.push({ key: "zoom-out", val: zoom });
		this.chan.$on("zoom-in", zoom);
		this.chan.$on("zoom-out", zoom);

		//Invert
		var invert = () => {
			var canv = $("#" + this.page.id).get(0);
			var ctx = canv.getContext("2d");
			var imgData = ctx.getImageData(0, 0, canv.width, canv.height);
			var data = imgData.data;
			console.log(data[0]);
			for (var i = 0; i < data.length; i += 4) {
				data[i] = Math.abs(data[i] - 255); // red
				data[i + 1] = Math.abs(data[i + 1] - 255); // green
				data[i + 2] = Math.abs(data[i + 2] - 255); // blue
			}
			// imgData.data = newData
			ctx.putImageData(imgData, 0, 0);
		};
		this.events.push({ key: "invert", val: invert });
		this.chan.$on("invert", invert);

		//Rotate
		var rotate = () => {
			var ele = $(this.$refs.essay);
			this.rotate += 90;
			ele.css("transform", "rotate(" + this.rotate + "deg)");
		};
		this.events.push({ key: "rotate", val: rotate });
		this.chan.$on("rotate", rotate);

		//Angle
		var onAngle = () => {
			var element = $(this.$refs.essay);
			//If we're already enabled, disable
			if (this.angleEnabled) {
				this.angleState = {};
				$(element).css("cursor", "default");
				$(element).off("click");
				this.angleEnabled = false;
				this.drawPDF();
				return;
			}
			this.angleEnabled = true;

			$(element).css("cursor", "crosshair");
			// console.log(state);
			$(element).on("click", event => {
				// console.log(deg);
				// console.log(state);
				var canv = $("#" + this.page.id).get(0);
				var ctx = canv.getContext("2d");

				var clickX = event.offsetX;
				var clickY = event.offsetY;

				if (!this.angleState.firstClick) {
					this.angleState.firstClick = {
						x: clickX,
						y: clickY
					};
					this.drawCrossPoint(ctx, clickX, clickY);
				} else if (!this.angleState.secondClick) {
					this.angleState.secondClick = {
						x: clickX,
						y: clickY
					};
					this.drawLine(ctx, this.angleState.firstClick, this.angleState.secondClick);
					this.drawCrossPoint(ctx, clickX, clickY);
				} else if (!this.angleState.thirdClick) {
					this.angleState.thirdClick = {
						x: clickX,
						y: clickY
					};
					this.drawLine(ctx, this.angleState.secondClick, this.angleState.thirdClick);
					this.drawCrossPoint(ctx, clickX, clickY);
					var angle =
						this.find_angle(
							this.angleState.firstClick,
							this.angleState.thirdClick,
							this.angleState.secondClick
						) *
						(180 / Math.PI);
					var rounded = Math.round(angle * 100) / 100;
					$(element).css("cursor", "not-allowed");

					this.drawText(ctx, rounded + "°", this.angleState.secondClick.x, this.angleState.secondClick.y);
					console.log(angle);
				} else {
					this.angleState = {};
					$(element).css("cursor", "crosshair");
					this.drawPDF();
				}
				console.log(this.angleState);
			});
		};
		this.events.push({ key: "angle-on", val: onAngle });
		this.chan.$on("angle-on", onAngle);

		var onhighlight = event => {
			var element = $(this.$refs.essay);

			this.highlightEnabled = !this.highlightEnabled;
			if (this.highlightEnabled) {
				$(element).mousedown(function(event) {
					var clickX = event.offsetX;
					var clickY = event.offsetY;
					var tag = $('<div class="tag"><div class="tag-closer"><i class="far fa-times"></i></div></div>');
					$(element).append(tag);
					tag.css("top", clickY);
					tag.css("left", clickX);

					var clickStart = event;

					$(element).mousemove(function(e) {
						// debugger;
						var moveX = e.offsetX;
						var moveY = e.offsetY;
						var width = moveX - clickX;
						var height = moveY - clickY;
						tag.css("width", width);
						tag.css("height", height);
					});
					$(document).mouseup(function(event) {
						$(element).off("mousemove");
						//TODO remove the temporary tage element & create a tag to add to the page.
					});
				});
			} else {
				$(element).off("mousedown");
			}
		};
		this.chan.$on("highlight", onhighlight);
	},

	mounted() {
		this.drawPDF();
	},
	destroyed() {
		var _this = this;
		_.each(this.events, e => {
			_this.chan.$off(e.key, e.val);
		});
	},

	methods: {
		drawPDF() {
			var zoom = store.get(this, "viewerScale");
			var size = this.sizes[zoom] || this.sizes[4];
			var targetWidth = 800 * size;
			console.log(targetWidth);

			var canvas = $("#" + this.page.id).get(0);
			var pdfPage = this.page.pdf;

			var viewport = pdfPage.getViewport(1);
			var thisScale = targetWidth / viewport.width;

			viewport = pdfPage.getViewport(thisScale);
			// canvas.id = canvId;
			//$(element).append(canvas);
			var context = canvas.getContext("2d");
			canvas.width = viewport.width;
			canvas.height = viewport.height;

			$(this.$refs.essay).css("max-width", viewport.width);
			$(this.$refs.essay).css("min-width", viewport.width);
			// debugger;

			var renderContext = {
				canvasContext: context,
				viewport: viewport
			};

			var now = new Date().getTime();
			var _this = this;
			pdfPage.render(renderContext).then(function() {
				console.log("PageRender:" + (new Date().getTime() - now));
				console.log(new Date().getTime() - _this.page.start);
			});
		},

		//Methods for angle tool
		drawCrossPoint(ctx, x, y) {
			ctx.rect(x - 10, y - 2, 18, 2);
			ctx.rect(x - 2, y - 10, 2, 18);
			ctx.fillStyle = "red";
			ctx.fill();
		},

		drawLine(ctx, start, end) {
			ctx.beginPath();
			ctx.moveTo(start.x, start.y);
			ctx.lineTo(end.x, end.y);
			ctx.strokeStyle = "red";
			ctx.stroke();
		},

		drawText(ctx, txt, x, y) {
			/// lets save current state as we make a lot of changes
			ctx.save();

			/// set font
			ctx.font = "30px Arial";

			/// draw text from top - makes life easier at the moment
			ctx.textBaseline = "top";

			/// color for background
			ctx.fillStyle = "#ffffff";

			/// get width of text
			var width = ctx.measureText(txt).width;

			/// draw background rect assuming height of font
			ctx.fillRect(x, y, width, 30);

			/// text color
			ctx.fillStyle = "red";

			/// draw text on top
			ctx.fillText(txt, x, y);

			/// restore original state
			ctx.restore();
		},

		find_angle(p0, p1, c) {
			var p0c = Math.sqrt(Math.pow(c.x - p0.x, 2) + Math.pow(c.y - p0.y, 2)); // p0->c (b)
			var p1c = Math.sqrt(Math.pow(c.x - p1.x, 2) + Math.pow(c.y - p1.y, 2)); // p1->c (a)
			var p0p1 = Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2)); // p0->p1 (c)
			return Math.acos((p1c * p1c + p0c * p0c - p0p1 * p0p1) / (2 * p1c * p0c));
		},

		calculateAngle(ctx, vert, one, two) {
			var lenV1 = len(vert, one);
			var lenV2 = len(vert, two);
			var len12 = len(one, two);

			console.log(lenV1, lenV2, len12);

			var top = Math.pow(lenV1, 2) + Math.pow(lenV2) - Math.pow(len12);
			var bottom = 2 * lenV1 * lenV2;
			return Math.acos(top / bottom);
		},

		len(point1, point2) {
			return Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
		}
	}
};
</script>

<style >
.tag {
	background-color: #ffff91;
	min-width: 10px;
	min-height: 10px;
	position: absolute;
	top: 0;
	left: 0;
	opacity: 0.5;
	-webkit-box-shadow: 2px 2px 0px 0px rgba(231, 237, 197, 0.41);
	-moz-box-shadow: 2px 2px 0px 0px rgba(231, 237, 197, 0.41);
	box-shadow: 2px 2px 0px 0px rgba(231, 237, 197, 0.41);
}

.tag-closer {
	position: absolute;
	display: none;
	top: -8px;
	right: -8px;
	height: 16px;
	width: 16px;
	/* content: "X"; */
	border-radius: 8px;
	background-color: purple;
	font-size: 8px;
	/* opacity: 0.8; */
	border: 1px;
	color: black;
}

.tag:hover .tag-closer {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/PDFMedia.vue